var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-success"},[_c('i',{staticClass:"fa fa-check-circle-o fa-lg icon-button mr-1",attrs:{"title":"Aprovar Pertinência"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarAprovar()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }